import React from 'react';
import {
  Alert, Checkbox, Divider, FormControlLabel, FormGroup, Grid, MenuItem,
  TextField, Typography,
} from '@mui/material';
import { CREW_SIZES, TRUCK_SIZES, EQUIPMENT_OPTIONS } from '../onboardingMapping.js';

export default function CrewsEquipmentStep({ answers, errors, onChange }) {
  const crews = answers.crews;
  const set = patch => onChange({ ...answers, crews: { ...crews, ...patch } });

  const toggleIn = (key, value) => set({
    [key]: crews[key].includes(value)
      ? crews[key].filter(v => v !== value)
      : [...crews[key], value],
  });

  return (
    <>
      <Typography variant="h5" fontWeight={600} gutterBottom>Crews & equipment</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Tell us what a typical crew looks like. This powers crew-size pricing in the next step.
      </Typography>

      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>STANDARD CREW SIZES</Typography>
      {errors.crewSizes && <Alert severity="error" sx={{ mb: 1.5 }}>{errors.crewSizes}</Alert>}
      <FormGroup row sx={{ mb: 2 }}>
        {CREW_SIZES.map(size => (
          <FormControlLabel
            key={size}
            control={<Checkbox checked={crews.crewSizes.includes(size)} onChange={() => toggleIn('crewSizes', size)} />}
            label={size === 5 ? '5+ movers' : `${size} movers`}
          />
        ))}
      </FormGroup>

      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>TRUCKS</Typography>
      <FormGroup row sx={{ mb: 2 }}>
        {TRUCK_SIZES.map(size => (
          <FormControlLabel
            key={size}
            control={<Checkbox checked={crews.trucks.includes(size)} onChange={() => toggleIn('trucks', size)} />}
            label={size}
          />
        ))}
      </FormGroup>

      <Grid container spacing={2.5} alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth type="number" label="Extra mover rate ($/hour, optional)" value={crews.extraMoverRate}
            helperText="Charged per additional mover beyond the base crew"
            inputProps={{ min: 0 }} onChange={e => set({ extraMoverRate: e.target.value })} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>EQUIPMENT & CAPABILITIES</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Informational — shown on your profile. It doesn't change your prices.
      </Typography>
      <FormGroup row>
        {EQUIPMENT_OPTIONS.map(item => (
          <FormControlLabel
            key={item}
            control={<Checkbox checked={crews.equipment.includes(item)} onChange={() => toggleIn('equipment', item)} />}
            label={item}
            sx={{ width: { xs: '50%', sm: '33%' } }}
          />
        ))}
      </FormGroup>
    </>
  );
}
